export const paginationFr = {
    line: 'ligne',
    lines: 'lignes',
    total: 'Total'
}
